import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=32e1d2cc"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"
import style0 from "./poster.vue?vue&type=style&index=0&id=32e1d2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports